<main class="main" id="top">
    <div class="container-fluid">
        <div class="row min-vh-100 flex-center g-0">
            <div class="col-lg-8 col-xxl-5 py-3 position-relative"><img class="bg-auth-circle-shape" src="../../../assets/img/icons/spot-illustrations/bg-shape.png" alt="" width="250"><img class="bg-auth-circle-shape-2" src="../../../assets/img/icons/spot-illustrations/shape-1.png" alt="" width="150">
                <div class="card overflow-hidden z-index-1">
                    <div class="card-body p-0">
                        <div class="row g-0 h-100">
                            <div class="col-sm-12 col-md-7 col-lg-7 bg-card-gradient" style="
                            display: flex; align-items: stretch;
                            width:48.8%;
                            height:700px;
                            background-size:contain;
                            background-position: center center;
                            background: linear-gradient(0deg, rgba(17, 1, 82, 0.7), rgba(17, 1, 82, 0.7)), url(../../../assets/img/login-img/8.png);;
                            ">
                                  <div class="position-relative p-3">
                                      <div class="z-index-1 position-relative p-3">
  
                                          <p class="mt-3 d-flex">
                                              <img src="assets/img/icons/spot-illustrations/new-logo-iceipt.png"
                                                  alt="iceipts logo" width="80" height="80">
                                          </p>
                                          <i class="fas fa-quote-left d-flex mt-5" style="color: #00DAF7;"></i>
                                          <br><br>
                                          <p class="opacity-75 text-white d-flex justify-content-start">
                                              The technology that looks impossible today will<br>be part of our life
                                              tomorrow. Iceipts technology<br>creating difference.
                                          </p>
                                          
                                          <p class="opacity-75 text-white d-flex">Sibanee kar</p>
                                      </div>
                                  </div>
                                <!-- <div class="position-relative p-4 pt-md-5 pb-md-7 light">
                                    <div class="bg-holder bg-auth-card-shape" style="background-image:url(../../../assets/img/icons/spot-illustrations/half-circle.png);">
                                    </div> -->
                                    <!--/.bg-holder-->

                                    <!-- <div class="z-index-1 position-relative"><a class="link-light mb-4 font-sans-serif fs-4 d-inline-block fw-bolder">falcon</a>
                                        <p class="opacity-75 text-white">With the power of Falcon, you can now focus only on functionaries for your digital products, while leaving the UI design on us!</p>
                                    </div>
                                </div> -->
                                <!-- <div class="mt-3 mb-4 mt-md-4 mb-md-5 light">
                                    <p class="mb-0 mt-4 mt-md-5 fs--1 fw-semi-bold text-white opacity-75">Read our <a class="text-decoration-underline text-white">terms</a> and <a class="text-decoration-underline text-white">conditions </a></p>
                                </div> -->
                            </div>
                            <div class="col-md-7 d-flex flex-center" style="width:50%">
                                <div class="p-4 p-md-5 flex-grow-1 form-body">
                                    <h3 style="font-size: 26px;"><b>Reset password</b></h3>
                                    <form class="mt-3">
                                        <div class="mb-3">
                                            <label class="form-label" for="card-reset-password">New Password</label>
                                            <input class="form-control" type="password" id="card-reset-password" />
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label" for="card-reset-confirm-password">Confirm
                                                Password</label>
                                            <input class="form-control" type="password" id="card-reset-confirm-password"/>                                            
                                        </div>
                                        <button class="btn btn-primary d-block w-100 mt-3" type="submit" name="submit" style="background: #110152;">Set password</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>